import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/TravelBooking.css';

const TravelBookingComponent = () => {
  const [bookingData, setBookingData] = useState({
    originalPrice: 0,
    discountedPrice: 0,
    emiAmount: 0,
    startingFrom: 'New Delhi',
    visa: false,
    visaPrice: 150,
    flightPrice: 100,
    flights: false,
  });

  const [tempBookingData, setTempBookingData] = useState(bookingData);
  const navigate = useNavigate();


  useEffect(() => {
    const fetchBookingData = async () => {
      try {
        const response = await fetch('YOUR_BACKEND_API_URL');
        const data = await response.json();
        setBookingData(data);
        setTempBookingData(data); // Sync temporary state with fetched data
      } catch (error) {
        console.error('Error fetching booking data:', error);
      }
    };
    fetchBookingData();
  }, []);

  const calculatePrice = (updatedBookingData) => {
    let price = updatedBookingData.originalPrice;
    if (updatedBookingData.visa) {
      price += updatedBookingData.visaPrice;
    }
    if (updatedBookingData.flights) {
      price += updatedBookingData.flightPrice;
    }
    return price;
  };

  const handleToggle = (field) => {
    setTempBookingData((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleViewPrice = () => {
    const updatedPrice = calculatePrice(tempBookingData);
    setBookingData((prev) => ({
      ...prev,
      ...tempBookingData,
      discountedPrice: updatedPrice,
    }));
  };

  return (
    <div>
    <div className="travel-booking-component">
      <div className="price-section">
        <p className="original-price">Starting @ <span>₹{bookingData.originalPrice}</span></p>
        <div style={{fontWeight:'700',fontSize:'1.5 rem'}}>₹{bookingData.originalPrice}</div>
      </div>
      <div className="booking-options">
        <div className="option">
          <span className="option-label">Visa</span>
          <button
            className={`tour-toggle-button ${tempBookingData.visa ? 'active' : ''}`}
            onClick={() => handleToggle('visa')}
          >
            <div className="toggle-slider" />
          </button>
        </div>
        <div className="option">
          <span className="option-label">Flights</span>
          <button
            className={`tour-toggle-button ${tempBookingData.flights ? 'active' : ''}`}
            onClick={() => handleToggle('flights')}
          >
            <div className="toggle-slider" />
          </button>
        </div>
        <div style={{ display: 'flex', justifyContent:'center',alignItems:'center',flexDirection: 'row', gap: '10px',backgroundColor:'#FBF4FF',paddingTop: '15px',paddingLeft:'15px',paddingRight:'15px',boxShadow: '0px 4px 4px 0px #00000040'}}>
          <div style={{ display: 'flex', justifyContent:'center', alignItems: 'center' ,color: '#321e5d'}}>
            <div className="discounted-price">₹{bookingData.discountedPrice}</div>
          </div>
        </div>
      </div>
    </div>



    <button
  className="book-now-button"
  onClick={() => navigate('/cart', { state: bookingData })}
>
  Proceed to cart
</button>



    </div>
  );
};

export default TravelBookingComponent;
